import { FC, JSX } from 'react';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';

import { StylesConfig } from '@player/content';
import Dropdown from '@semcore/ui/dropdown';

import ColorPicker from './ColorPicker';

interface IColorSettingProps extends ReturnType<
  typeof useFormContext<{ config: StylesConfig }>
> {
  propName: FieldPath<{ config: StylesConfig }>;
  title: string;
}

const ColorSetting: FC<IColorSettingProps> = ({
  title,
  control,
  propName,
}): JSX.Element => {
  return (
    <div className="flex grow items-center gap-2">
      <div className="flex grow text-base font-light leading-5">{title}</div>
      <Controller
        control={control}
        name={propName}
        render={({ field: { value, onChange } }) => (
          <Dropdown interaction="click" placement="bottom" stretch="min">
            <Dropdown.Trigger id="dropdown-trigger">
              <div className="flex gap-2 rounded bg-black/[.02] px-2 py-1 dark:bg-white/[.02]">
                <div className="text-base font-light leading-5">
                  {(value as string).toLocaleUpperCase()}
                </div>
                <div
                  className="h-5 w-5 rounded-full border"
                  style={{
                    backgroundColor: value as string,
                    borderColor:
                      (value as string).toLocaleLowerCase() === '#ffffff'
                        ? 'black'
                        : (value as string),
                  }}
                />
              </div>
            </Dropdown.Trigger>

            <Dropdown.Popper className="border-0 !bg-transparent !shadow-none">
              <ColorPicker value={value as string} onChange={onChange} />
            </Dropdown.Popper>
          </Dropdown>
        )}
      />
    </div>
  );
};

export default ColorSetting;
